import React, { useEffect } from 'react';
import './App.css';
import './Sizing.css';
import 'bootstrap/dist/css/bootstrap.min.css'
import "@fontsource/open-sans"
import Header from "./components/Header"
import Hero from "./components/Hero"
import Invitation from "./components/Invitation"
import Events from "./components/Events"
import Rules from "./components/Rules"
import Gallery from "./components/Gallery"
import Rsvp from "./components/Rsvp"
import Message from "./components/Message"
import Map from "./components/Map"
import Footer from "./components/Footer"
import BackToTop from "./components/BackToTop"
import AOS from "aos"
import "aos/dist/aos.css"

export default function App() {

    const authenticate = () =>{
        return new Promise(resolve => setTimeout(resolve, 2000)) // 2 seconds
    }

    useEffect(() => {
        AOS.init();
        authenticate().then(() => {
        const ele = document.getElementById('ipl-progress-indicator')
        if (ele) {
            // fade out
            ele.classList.add('available')
            setTimeout(() => {
            // remove from DOM
            ele.outerHTML = ''
            }, 2000)
        }
        })
    },[])

    return (
        <div>
            {/* <Header /> */}
            <Hero/>
            <main>
            <Invitation/>
            <Events/>
            <Rsvp/>
            <Map/>
            <Rules/>
            <Gallery/>
            <Message/>
            </main>
            <Footer/>
            <BackToTop/>
        </div>
    );
}